<h3 class="vc-title-s login__title" i18n="@@LOGIN_MODAL.TITLE">Log in</h3>

<div class="login__formContainer">
  <vc-facebook-connect class="login__facebookLogin" [type]="'login'"></vc-facebook-connect>

  <div class="login__or" i18n="@@LOGIN_MODAL.OR">or</div>

  <form
    novalidate
    [formGroup]="loginForm"
    [ngClass]="{hasLoader: pending$ | async}"
    id="loginForm"
    class="login__form"
    (change)="clearErrorMessage()"
  >
    <div *ngIf="error" class="vc-form__error">{{ error }}</div>

    <div class="login__vclogin">
      <!-- EMAIL -->
      <div class="form-group vc-form-text register__field register__vcregister">
        <input
          #userEmail
          type="email"
          id="user_email"
          class="vc-form-text__input"
          formControlName="email"
          required
          autocapitalize="none"
          (keypress)="stopEnterPropagation($event)"
          (focusout)="onEmailFocusOut()"
        />
        <label class="vc-form-text__label" for="user_email">
          <div *ngIf="email?.errors && email.dirty">
            <span *ngIf="email?.errors.required" i18n="@@LOGIN_MODAL.ERROR_REQUIRED_EMAIL">Email is required</span>
            <span *ngIf="email?.errors.pattern" i18n="@@LOGIN_MODAL.ERROR_PATTERN_EMAIL">Incorrect email address</span>
          </div>
          <span *ngIf="email.valid || !email.dirty"
            ><ng-container i18n="@@LOGIN_MODAL.EMAIL">Email</ng-container>*</span
          >
        </label>
      </div>
      <!-- END EMAIL -->

      <!-- PASSWORD -->
      <div class="vc-form-text login__field">
        <input
          #userPassword
          type="password"
          [attr.type]="displayPassword ? 'text' : 'password'"
          name="password"
          id="user_password"
          class="vc-form-text__input"
          formControlName="password"
          required
          autocapitalize="none"
          (keypress)="stopEnterPropagation($event)"
          (focusout)="onPasswordFocusOut()"
        />
        <label class="vc-form-text__label" for="user_password">
          <div *ngIf="password.errors && password.dirty">
            <span *ngIf="password?.errors.required" i18n="@@LOGIN_MODAL.ERROR_REQUIRED_PASSWORD"
              >Password is required</span
            >
          </div>
          <span *ngIf="password.valid || password.pristine"
            ><ng-container i18n="@@LOGIN_MODAL.PASSWORD">Password</ng-container>*</span
          >
        </label>

        <button
          *ngIf="!displayPassword && !password.pristine"
          class="togglePasswordBtn vc-form-text__action"
          (click)="togglePassword()"
          i18n="@@REGISTER_MODAL.SHOW_PASSWORD_INPUT"
        >
          Show
        </button>
        <button
          *ngIf="displayPassword && !password.pristine"
          class="vc-form-text__action"
          (click)="togglePassword()"
          i18n="@@REGISTER_MODAL.HIDE_PASSWORD_INPUT"
        >
          Hide
        </button>
      </div>
      <!-- END PASSWORD -->

      <div class="login__options">
        <div class="vc-form-checkbox">
          <input
            class="vc-form-checkbox__input"
            name="remember_me"
            id="remember_me"
            type="checkbox"
            autocomplete="off"
          />
          <label
            class="vc-form-checkbox__label login__checkboxLabel"
            for="remember_me"
            i18n="@@LOGIN_MODAL.REMEMBER_ME_CHECKBOX"
            >Remember me</label
          >
        </div>
        <button
          class="login__forgottentPasswordBtn"
          (click)="displayResetPasswordComponent()"
          i18n="@@LOGIN_MODAL.FORGOTEN_PASSWORD"
        >
          Forgotten password
        </button>
      </div>

      <button
        type="submit"
        class="vc-btn vc-btn--large vc-btn--full vc-btn--primary login__submit"
        (click)="isChromeApp ? onSubmitChrome() : onSubmit()"
        [disabled]="(pending$ | async) || (!loginForm.valid && !isChromeApp)"
        i18n="@@LOGIN_MODAL.CONNECT_BUTTON"
      >
        Connect
      </button>

      <p class="login__requiredFieldMention">
        <ng-container i18n="@@LOGIN_MODAL.MANDATORY_FIELD">Mandatory field</ng-container>*
      </p>
    </div>
  </form>
</div>
